if (!customElements.get('ob-product-carousel')) {
  customElements.define('ob-product-carousel', class extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.abort = new AbortController();
      this.track = this.querySelector('[data-ob-track]');
      this.controls = this.querySelector('[data-ob-controls]');
      this.pending = false;
      this.addEventListener('click', event => {
        const button = event.target.closest('button');
        if (!button || !this.track) return;
        if (button.hasAttribute('data-ob-prev') || button.hasAttribute('data-ob-next')) {
          const width = this.track.querySelector('.ob-product-slide')?.getBoundingClientRect().width || this.track.clientWidth;
          const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
          const direction = button.hasAttribute('data-ob-prev') ? -1 : 1;
          this.track.scrollBy({ left: direction * (width + gap), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
        }
      }, { signal: this.abort.signal });
      this.addEventListener('submit', event => this.addProduct(event), { signal: this.abort.signal });
      if (this.track) {
        this.track.addEventListener('scroll', () => this.updateControls(), { passive: true, signal: this.abort.signal });
        this.resizeObserver = new ResizeObserver(() => this.updateControls());
        this.resizeObserver.observe(this.track);
      }
      this.updateControls();
    }

    disconnectedCallback() {
      this.abort?.abort();
      this.resizeObserver?.disconnect();
      this.abort = null;
    }

    updateControls() {
      if (!this.track || !this.controls) return;
      const last = this.track.scrollWidth - this.track.clientWidth;
      this.controls.hidden = last < 2;
      this.querySelector('[data-ob-prev]').disabled = this.track.scrollLeft < 2;
      this.querySelector('[data-ob-next]').disabled = this.track.scrollLeft > last - 2;
    }

    async addProduct(event) {
      const form = event.target.closest('.ob-card-form');
      if (!form || event.submitter?.name !== 'add' || !window.fetch) return;
      event.preventDefault();
      if (this.pending || !form.reportValidity()) return;
      this.pending = true;
      const buttons = [...this.querySelectorAll('[data-ob-add]')];
      const enabled = buttons.filter(button => !button.disabled);
      const error = form.querySelector('[data-ob-error]');
      enabled.forEach(button => { button.disabled = true; button.setAttribute('aria-busy', 'true'); });
      if (error) { error.hidden = true; error.textContent = ''; }
      try {
        const endpoint = new URL(this.dataset.addUrl || form.action, window.location.origin);
        if (endpoint.origin !== window.location.origin) throw new Error(this.dataset.cartError);
        if (!endpoint.pathname.endsWith('.js')) endpoint.pathname += '.js';
        const response = await fetch(endpoint, { method: 'POST', body: new FormData(form), credentials: 'same-origin', headers: { Accept: 'application/json' } });
        const result = await response.json();
        if (!response.ok) throw new Error(typeof result.description === 'string' ? result.description : this.dataset.cartError);
        document.dispatchEvent(new CustomEvent('apps:product-added-to-cart', { detail: { product: result } }));
        const status = this.querySelector('[data-ob-status]');
        if (status) status.textContent = this.dataset.added;
        const trigger = document.querySelector('[data-js-cart-icon]');
        if (trigger && document.querySelector('.quick-cart')) trigger.click();
        else window.location.assign(this.dataset.cartUrl);
      } catch (caught) {
        if (error) { error.textContent = caught.message || this.dataset.cartError; error.hidden = false; }
      } finally {
        this.pending = false;
        enabled.forEach(button => { button.disabled = false; button.removeAttribute('aria-busy'); });
      }
    }
  });
}
